// extracted by mini-css-extract-plugin
export default {"link":"Link__link___plGt2","blueLink":"Link__blueLink___BhE5_","underline":"Link__underline___K1Y7j","bold":"Link__bold___JGJNO"};